/**
 * Common Encryption scheme.
 *
 *
 * @beta
 */
export const CENC = 'cenc'
